module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg25.639ae3d6.jpg";